var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"verba-fields"},[_c('h3',{staticClass:"title"},[_vm._v("Verba")]),_c('CustomInput',{staticClass:"max-w-350",attrs:{"type":"currency","placeholder":"Gostaria de pagar até:","example":"R$ 1.000,00"},model:{value:(_vm.verba),callback:function ($$v) {_vm.verba=$$v},expression:"verba"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }